import React from 'react';
import DialogMessage from '../../Dialog';
import { prettyDate } from '../../../utils/date';

const ModalNotEnoughQuota = ({data, ...props}) => {
    return <DialogMessage {...props}>
        <strong style={{fontSize: '1.5em', textAlign: 'center', width: '100%', display: 'block'}}>Não foi possível distribuir as quotas, verifique os conflitos:</strong>
        <hr />
        <table 
         id="client-quota-not-enough-table"
         data-cy="client-quota-not-enough-table"
         style={{width: '100%'}}>
            <thead>
                <tr>
                    <th>Data</th>
                    <th style={{ textAlign: 'right' }}>Cotas disponíveis</th>
                    <th style={{ textAlign: 'right' }}>Cotas Alocadas</th>
                </tr>
            </thead>
            <tbody>
                {data && data.map((d, index) => (
                    <tr key={index}>
                        <td>{prettyDate(d.date)}</td>
                        <td style={{ textAlign: 'right' }}>{d.total}</td>
                        <td style={{textAlign: 'right'}}>{d.intended}</td>
                    </tr>
                ))}
            </tbody>
        </table>
        <hr />
    </DialogMessage>
}

export default ModalNotEnoughQuota;